module.exports = __webpack_public_path__ + "static/image/company/pc/image_sustainable_declaration.ver2_0_2.jpg?a63b3cee";